import { Box } from '@mui/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { SiteSettingsView } from '@/features/site/components/settings/SiteSettingsView'
import { SiteSelector } from '@/features/site/components/SiteSelector'
import { SiteDetailsRouteInformation } from '@/features/site/pages/constants'
import { useSiteDetails } from '@/features/site/pages/SiteDetails'

export const SiteDetailsSettings = () => {
  const { site, siteDetailsCommonBreadcrumbs, setPageConfig } = useSiteDetails()
  const { t } = useTranslation()

  useEffect(() => {
    setPageConfig({
      title: t('customer_details.tabs.settings.title'),
      pageTag: 'site-details-settings',
      breadcrumbs: siteDetailsCommonBreadcrumbs,
      appBarContent: <SiteSelector siteUuid={site.uuid} />,
      activeTab: SiteDetailsRouteInformation.SETTINGS.navigationPath,
    })
  }, [])

  return (
    <Box my={2} sx={{ width: '100%' }}>
      {site && <SiteSettingsView site={site} />}
    </Box>
  )
}
